import gql from "graphql-tag";

import { EnableDisableLearnerAllowanceFragment } from "../routes/LearnerAllowances/hooks/useEnableDisableLearnerAllowance";

export const ChildFragment = gql`
  fragment ChildFragment on Child {
    uid
    name
    age
    birthMonth
    birthYear
    email
    avatar
    unlockedAvatars
    pronoun
    intro
    deleted_at
    email_confirmed_at
    optedOutOfPersonalizedRecommendationsAt
    isLoginEnabled
    username
    hasPassword
  }
`;

export const CurrentUserChildFragment = gql`
  fragment CurrentUserChildFragment on Child {
    ...ChildFragment
    allowance {
      uid
      ...EnableDisableLearnerAllowanceFragment
    }
  }
  ${ChildFragment}
  ${EnableDisableLearnerAllowanceFragment}
`;
